import { render } from "./index.vue?vue&type=template&id=d27cac50&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d27cac50&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=d27cac50&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27cac50"]])

export default __exports__